exports = module.exports = require(21);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require(23);
exports.Duplex = require(19);
exports.Transform = require(22);
exports.PassThrough = require(20);
